<template>
  <div>
    <v-row no-gutters>
      <v-col class="pt-1 ml-2 font18 bold headline2">รางวัลของฉัน</v-col>
      <v-col class="pt-1 ml-4 mb-2 font14 bold headline1" align="right"
        ><v-btn @click="getHistory() === true" color="#eee" rounded
          >ประวัติแลกของรางวัล<v-icon class="headline1 ml-1"
            >mdi-clock-outline</v-icon
          ></v-btn
        ></v-col
      >
    </v-row>
    <v-card>
      <v-tabs v-model="tab" :background-color="$bgColor" dark fixed-tabs>
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1"> รางวัลของฉัน </v-tab>

        <v-tab href="#tab-2"> รางวัลหมดอายุ </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item :value="'tab-1'" v-if="items">
          <v-card
            v-for="(item, i) in items.filter(
              (a) =>
                new Date(momenDate_1(a.endDate)).getTime() > today.getTime()
            )"
            :key="i"
            class="mb-10 mt-4"
            height="auto"
          >
            <v-row>
              <v-col class="col-5 pa-2"
                ><v-img :src="item.pictureUrl" height="auto" class="link"></v-img
              ></v-col>
              <v-col class="col-7">
                <v-row class="font16 bold headline1">
                  <v-col class="pl-0 pt-2 pb-3">{{ item.name }}</v-col>
                </v-row>
                <v-row class="font14 icon2">
                  <v-col class="pl-0 pt-0 pb-0">ใช้ก่อนวันที่</v-col>
                </v-row>
                <v-row class="font14 headline1">
                  <v-col class="pl-0 pt-0 pb-0">
                    {{ format_date_thai(item.endDate.split(' ').slice(0, -1)) }}
                  </v-col>
                </v-row>
                <v-col class="pt-4 pb-2 text-end pr-4">
                    <v-btn
                      style="background-color: #9fe6a0"
                      v-if="
                        new Date(momenDate_1(item.endDate)).getTime() >
                        today.getTime()
                      "
                      rounded
                      x-small
                      class="headline1"
                      @click="useReward(item)"
                      >ใช้ของรางวัล</v-btn
                    >
                  </v-col>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-2'" v-if="items">
          <v-card
            v-for="(item, i) in items.filter(
              (a) =>
                new Date(momenDate_1(a.endDate)).getTime() < today.getTime()
            )"
            :key="i"
            class="mb-10 mt-4"
            height="114"
          >
            <v-row>
              <v-col class="col-5 pt-0"
                ><v-img :src="item.pictureUrl" height="114" class="link"></v-img
              ></v-col>
              <v-col class="col-7">
                <v-row class="font16 bold headline1">
                  <v-col class="pl-0 pt-2 pb-3">{{ item.name }}</v-col>
                </v-row>
                <v-row class="font14 icon2">
                  <v-col class="pl-0 pt-0 pb-3">ใช้ก่อนวันที่</v-col>
                </v-row>
                <v-row class="font14 headline1">
                  <v-col class="pl-0 pt-0 pb-0">
                    {{ format_date_thai(item.endDate.split(' ').slice(0, -1)) }}
                  </v-col>
                  <v-col class="pt-1 text-end pr-6">
                    <v-btn
                      v-if="
                        new Date(momenDate_1(item.endDate)).getTime() <
                        today.getTime()
                      "
                      disabled
                      outlined
                      rounded
                      x-small
                      class="headline1"
                      @click="useReward(item)"
                      >expired</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="dialog && use">
        <v-toolbar dark :color=" $bgColor ">
          <v-btn icon dark @click="closeUseReward">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Use Reward</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list subheader>
          <v-subheader>โปรดแสดง QR Code นี้ต่อพนักงาน</v-subheader>
          <v-divider></v-divider>
        </v-list>
        <v-row>
          <v-col class="text-center headline1 ma-0 pa-0 font24">
            {{ use.rewardCode }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <qrcode-usecode
              :shopId="use.shopId"
              :rewardId="use.rewardId"
              :rewardCode="use.rewardCode"
              :lineUserId="profile.userId"
              :memberId="profile.memberId"
            ></qrcode-usecode>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="text-center headline1 font20">
            รายละเอียดของรางวัล
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="d-flex flex-column justify-space-between align-center"
            ><v-img :src="use.pictureUrl" max-width="150"></v-img
          ></v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-row class="font16 bold headline1">
              <v-col class="pl-0 pt-2 pb-3">{{ use.name }}</v-col>
            </v-row>
            <v-row class="font14 icon2">
              <v-col class="pl-0 pt-0 pb-3"
                >ใช้ก่อนวันที่
                <span class="icon1">{{ use.endDate }}</span></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogRewardhistory"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      style="border-radius: 10 ! important"
    >
      <v-card>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QRCodeUserCode from './QRCodeUseCode'
export default {
  name: 'AllRewards',
  components: {
    'qrcode-usecode': QRCodeUserCode
  },
  data () {
    return {
      items: null,
      use: null,
      dialog: false,
      today: new Date(),
      tab: null,
      dialogRewardhistory: false,
      rewardHistory: null,
      member: null,
      profile: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // await this.liffGetProfile()
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()

    this.getReward()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async getReward () {
      const result = await this.callBeTaskAPI(
        'get',
        '/rewardCode/line/get?redeemStatus=get'
      )
      if (result) {
        if (Array.isArray(result)) {
          this.items = result.sort(
            (a, b) => new Date(b.endDate) - new Date(a.endDate)
          )
        }
      }
    },
    async getHistory () {
      const result = await this.callBeTaskAPI(
        'get',
        '/rewardCode/lineHistory/get?redeemStatus=use'
      )
      if (result) {
        if (Array.isArray(result)) {
          this.rewardHistory = result
        }
      }
      this.dialogRewardhistory = true
    },
    useReward (item) {
      this.use = item
      this.dialog = true
    },
    closeUseReward () {
      this.items = null
      this.getReward()
      this.dialog = false
    },
    copyText () {
      let textToCopy = this.$refs.textToCopy[0].$el.querySelector('input')
      textToCopy.select()
      document.execCommand('copy')
    }
  }
}
</script>
<style scoped>
a.v-tab {
  text-decoration: none;
}
/* .dialog-border-radius {
  border-radius: 20px;
} */
</style>



// WEBPACK FOOTER //
// src/components/MyRewards.vue